import React from 'react';

interface AudioWebsocketDetection {
  id: string;
  sessionId: string;
  date: number;
  commandId: string;
  cardId?: string;
  projectId: string;
  contextChange?: string;
  topicTextLower?: string;
  sessionActivityTrigger?: string;
}

export interface AudioWebsocketDetectionResponse {
  detection?: AudioWebsocketDetection;
  transcript?: string;
  card?: {
    id: string;
    title: string;
  }
}

export interface SessionActivityTriggerMessage {
  type: 'sessionActivityTrigger',
  activate: boolean,
  detection: AudioWebsocketDetectionResponse,
}

interface DetectionMessage {
  type: 'detection';
  message: AudioWebsocketDetectionResponse
}

interface SessionChangeMessage {
  type: 'session-change',
  sessionId: string,
  IsActive: boolean,
  detection: AudioWebsocketDetectionResponse,
}

interface EndOfSessionMessage {
  type: 'endSessionAck';
  sessionId: string;
}

interface CallStartMessage {
  type: 'callStart'
}

interface RestartAudioStreamMessage {
  type: 'restart-audio-stream'
}

interface SessionTimeoutMessage {
  type: 'sessionTimeout',
  activate: boolean,
  detection: AudioWebsocketDetectionResponse
}

export type AudioWebhookResponse = (
  DetectionMessage
  | EndOfSessionMessage
  | SessionActivityTriggerMessage
  | SessionChangeMessage
  | CallStartMessage
  | RestartAudioStreamMessage
  | SessionTimeoutMessage
);

export interface SessionConnectionContextProps {
  latestMessage: AudioWebhookResponse | null;
}

export const SessionConnectionContext = React.createContext<SessionConnectionContextProps | null>(null);

export default function useSessionConnectionContext() {
  const context = React.useContext(SessionConnectionContext);
  if (context === null) throw new Error('useSessionAudioWebsocketContext must be used within a SessionAudioWebsocketContextProvider');
  return context;
}
